// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7t-0";
export var startPickingButton = "_7t-1";